import React, { useState } from "react";
import axios from "axios";
import { Card, Input, Button, Typography, message, App } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import "./LoginPage.css";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode"; // Install via: npm install jwt-decode

const { Title, Text, Link } = Typography;

const LoginPage = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      console.log(decoded);
      // Optional: Send to backend for token exchange/login
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/google-login`,
        {
          IdToken: credentialResponse.credential,
        }
      );

      if (
        (response.data.data || {}).credentials &&
        response.data.data.credentials.token
      ) {
        localStorage.setItem("token", response.data.data.credentials.token);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        navigate("/dashboard/home");
        message.success("Login successful!");
      }
    } catch (error) {
      console.error("Google login error:", error);
      message.error("Login failed");
    }
  };

  const handleLogin = async () => {
    if (!username || !password) {
      message.warning("Please enter both username and password");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/login`,
        {
          Username: username,
          Password: password,
        }
      );

      // Handle success (e.g., save token, redirect user, etc.)
      // console.log("Login successful:", response.data);
      if (
        (response.data.data || {}).credentials &&
        response.data.data.credentials.token
      ) {
        localStorage.setItem("token", response.data.data.credentials.token);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        navigate("/dashboard/home");
      }
      message.success("Login successful!");
    } catch (error) {
      console.error("Login failed:", error);

      const errorMsg =
        error.response?.data?.message || "Something went wrong during login.";
      console.log(errorMsg);
      notification.warning({
        message: errorMsg,
      });
      console.log("ok");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="logo-container">
          <img src={require("../../assets/logo.png")} alt="logo" />
        </div>
        <Title level={3}>Sign In</Title>
        <Text type="secondary">Simplify Your PDF Tasks Effortlessly</Text>

        <div className="form-item">
          <Text strong>Email or Username</Text>
          <Input
            placeholder="Enter your email or username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="form-item">
          <Text strong>Password</Text>
          <Input.Password
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </div>

        <div className="forgot-password">
          <Link href="/forgotpass">Forgot Password?</Link>
        </div>

        <Button
          type="primary"
          block
          className="login-button"
          onClick={handleLogin}
          loading={loading}
        >
          Login
        </Button>
        {process.env.REACT_APP_GOOGLE_CLIENT_ID ? (
          <div style={{ marginTop: "16px", textAlign: "center" }}>
            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={() => message.error("Google login failed")}
            />
          </div>
        ) : (
          []
        )}

        <div className="signup-text">
          New on our platform? <Link href="/register">Create an account</Link>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
